<template>
  <div class="week-reward-config">
    <div class="week-reward-config--process">
      <span>奖励类型：</span>
      <el-select v-model="searchData.awardType" placeholder="请选择奖励类型">
        <el-option label="All" :value="0"></el-option>
        <el-option v-for="item in rewardType" :label="item.name" :value="item.value"></el-option>
      </el-select>
      <span>是否可用：</span>
      <el-select v-model="searchData.valid" placeholder="请选择是否可用">
        <el-option label="可用" :value="1"></el-option>
        <el-option label="不可用" :value="0"></el-option>
      </el-select>
      <el-button type="primary" @click="getRewardList">查询</el-button>
      <el-button type="success" @click="openDrawer(null)">新增</el-button>
    </div>
    <el-table :data="rewardList" style="width: 100%" height="660px">
      <el-table-column prop="id" label="id">
      </el-table-column>
      <el-table-column prop="awardType" label="奖品类型">
        <template slot-scope="scope">
          {{ rewardType.find(item => item.value === scope.row.awardType).name }}
        </template>
      </el-table-column>
      <el-table-column prop="dataId" label="装扮id"></el-table-column>
      <el-table-column prop="name" label="名称"> </el-table-column>
      <el-table-column prop="nums" label="数量"> </el-table-column>
      <el-table-column prop="rankType" label="奖励对象">
        <template slot-scope="scope">
          {{ scope.row.rankType === 1 ? '至尊周星' : '璀璨周星' }}
        </template>
      </el-table-column>
      <el-table-column prop="valid" label="是否有效">
        <template slot-scope="scope">
          {{ scope.row.valid === 1 ? '有效' : '无效' }}
        </template>
      </el-table-column>
      <el-table-column prop="desc" label="描述"> </el-table-column>
      <el-table-column prop="awardIcon" label="图标">
        <template slot-scope="scope">
          <img :src="scope.row.awardIcon" alt="" style="width: 50px;">
        </template>
      </el-table-column>
      <el-table-column prop="operator" label="操作人"> </el-table-column>
      <el-table-column prop="ctime" label="创建时间"> 
        <template slot-scope='scope'>
          {{ formatDay(scope.row.ctime) }}
        </template>
      </el-table-column>
      <el-table-column prop="mtime" label="修改时间">
        <template slot-scope='scope'>
          {{ formatDay(scope.row.mtime) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="openDrawer(scope.row)">修改</el-button>
          <el-button size="mini" type="danger" @click="updateValid(scope.row)"> {{ scope.row.valid === 1 ? '停用' : '启用'
          }}</el-button>
        </template>
      </el-table-column>

    </el-table>
    <el-drawer :title="dialogData.title" :before-close="handleClose" :visible.sync="dialogData.visible" direction="rtl"
      custom-class="demo-drawer" ref="drawer">
      <div class="demo-drawer__content">
        <el-form :model="dialogData.data">
          <el-form-item label="奖品类型" label-width="110px">
            <el-select v-model="dialogData.data.awardType" placeholder="请选择奖品类型">
              <el-option v-for="item in rewardType" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="礼物/装扮id" label-width="110px">
            <el-input v-model="dialogData.data.dataId"></el-input>
          </el-form-item>
          <el-form-item label="名称" label-width="110px">
            <el-input v-model="dialogData.data.name"></el-input>
          </el-form-item>
          <el-form-item label="数量" label-width="110px">
            <el-input v-model="dialogData.data.nums"></el-input>
          </el-form-item>
          <el-form-item label="奖励对象" label-width="110px">
            <el-select v-model="dialogData.data.rankType" placeholder="请选择奖励对象">
              <el-option label="至尊周星" :value="1"></el-option>
              <el-option label="璀璨周星" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否有效" label-width="110px">
            <el-select v-model="dialogData.data.valid" placeholder="请选择是否有效">
              <el-option label="有效" :value="1"></el-option>
              <el-option label="无效" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="描述" label-width="110px">
            <el-input type="textarea" v-model="dialogData.data.desc"></el-input>
          </el-form-item>
          <el-form-item label="奖品图标" label-width="110px">
            <UploadSingleImg v-model="dialogData.data.awardIcon" :on-upload="uploadFile"/>
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary" @click="submitChange" :loading="dialogData.loading">{{ dialogData.loading ? '提交中 ...' : '确 定'
          }}</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import UploadSingleImg from '@/components/UploadSingleImg/UploadSingleImg'
import dayjs from "dayjs"

import { getRewardTypeConst, getWeekRewardList, createWeekReward, updateWeekReward, updateWeekRewardValid } from '@/api/weekStarRequest'
export default {
  components:{
    UploadSingleImg
  },
  data() {
    return {
      searchData: {
        awardType: 0,
        valid: 1
      },
      rewardType: [],
      rewardList: [],
      dialogData: {
        visible: false,
        title: '新增周星奖励配置',
        type: 1, // 1创建 2修改
        loading: false,
        data: {
          awardType: 1,
          dataId: '',
          name: '',
          nums: '',
          rankType: 1,
          valid: 1,
          desc: '',
          awardIcon: '',
        }
      }
    }
  },
  methods: {
     // 时间格式化
     formatDay(timestamp) {
      if (timestamp === 0) {
        return '无'
      }
      return dayjs(timestamp * 1000).format("YYYY-MM-DD HH:mm:ss")
    },
    async uploadFile(file){
      const formData = new FormData()
      formData.append('file', file)
      formData.append('cover', 1)
      formData.append('dir', 'activity/gift/icon/')
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.hostmgr_upload +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token,
        formData
      )
      return {code: res.code, url: res.data}
    },
    // 弹窗将要关闭事件
    handleClose() {
      this.dialogData = {
        visible: false,
        title: '新增周星奖励配置',
        type: 1, // 1创建 2修改
        loading: false,
        data: {
          awardType: 1,
          dataId: '',
          name: '',
          nums: '',
          rankType: 1,
          valid: 1,
          desc: '',
          awardIcon: '',
        }
      }

    },
    // 打开弹窗的 
    openDrawer(row) {
      if (row) {
        this.dialogData.title = '修改周星奖励配置'
        this.dialogData.type = 2
        this.dialogData.data = JSON.parse(JSON.stringify(row))
      } else {
        this.dialogData.title = '新增周星奖励配置'
        this.dialogData.type = 1
      }
      this.dialogData.visible = true
    },
    // 提交修改或新增的，对接接口
    async submitChange() {
      this.dialogData.loading = true
      // 创建
      let res = null
      if (this.dialogData.type === 1) {
        res = await createWeekReward(this.dialogData.data)
      } else {
        // 修改
        res = await updateWeekReward(this.dialogData.data)
      }
      if (res.code !== 0) return this.$message.error(res.msg);
      this.$message.success('success');
      await this.getRewardList()
      this.dialogData.loading = false
      this.dialogData.visible = false

    },
    // 获取配置类型
    async getRewardType() {
      const res = await getRewardTypeConst()
      if (res.code !== 0) return this.$message.error(res.msg);
      this.rewardType = res.data
    },
    // 获取配置列表
    async getRewardList() {
      const res = await getWeekRewardList(this.searchData)
      if (res.code !== 0) return this.$message.error(res.msg);
      this.rewardList = res.data;
      this.$message.success('search success')

    },
    // 更新状态
    updateValid(obj) {
      this.$confirm('是否更改状态?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await updateWeekRewardValid({
          id: obj.id,
          valid: Math.abs(obj.valid - 1)
        })
        if (res.code !== 0) return this.$message.error(res.msg);
        this.$message.success('change success')
        this.getRewardList()
      }).catch(() => {
      });
    }
  },
  mounted() {
    this.getRewardType()
    this.getRewardList()

  }

}
</script>

<style scoped lang="scss">
.week-reward-config {
  &--process {
    .el-select {
      margin-right: 20px;
    }
  }
}

.demo-drawer {
  &__content {
    margin: 0 20px;
    height: 100%;
    display: flex;
    flex-direction: column;

    form {
      flex: 1;
    }

  }

  &__footer {
    display: flex;
    width: 100%;
    margin-bottom: 30px;

    >* {
      flex: 1;
    }
  }

}
</style>